module.exports = __webpack_public_path__ + "static/media/TableCorner2_After.dbfbb15b.jpg";